import { ordersConstants } from '../_constants';

const initialState = {
    data: [],
    loading: false
}

export function orders (state = initialState, action){
    switch(action.type){
        case ordersConstants.ORDERS_LOADING:
        return {
            ...state,
            loading: true,
            data: []
        };
        case ordersConstants.ORDERS_LOADED:
        return {
            ...state,
            loading: false,
            data: action.data
        }
        case ordersConstants.ORDERS_ERROR:
        return{
            ...state,
            loading: false,
            data: []
        }
        default:
            return state;
    }
}